/* eslint-disable import/no-default-export, max-lines-per-function, react/prop-types */
import CheckIcon from "assets/icons/check.svg";
import { cn } from "tailwind-variants";

export default function PinApprovalCard({
  isApproving = false,
  isRejecting = false,
  disabled = false,
  compact = false,
  // @ts-expect-error TS migration
  onApprove,
  // @ts-expect-error TS migration
  onReject,
  ...restProps
}) {
  return (
    <div
      {...restProps}
      // @ts-expect-error TS migration
      className={cn("rounded-[10px] bg-[#F6EDFF]", compact ? "p-2" : "p-3", restProps.className)}
      data-testid="pinning-image-approval"
    >
      <p className="m-0 text-[10px] font-bold uppercase tracking-wide text-[#9225FF]">
        AI Preview Ready
      </p>
      <p className={cn("m-0 mt-1 font-semibold text-gray-900", compact ? "text-xs" : "text-sm")}>
        {" "}
        Does this look right?{" "}
      </p>
      <p className={cn("m-0 mt-0.5 text-gray-900", compact ? "text-xs" : "text-sm")}>
        {" "}
        Toggle the image above to compare.{" "}
      </p>
      <div className={cn("flex gap-2", compact ? "mt-2" : "mt-3")}>
        <button
          className={cn(
            "rounded-lg border border-gray-300 bg-white px-3.5 py-2 text-xs font-medium text-gray-900 [font-family:inherit] hover:bg-gray-50 disabled:pointer-events-none disabled:opacity-25",
            compact ? "flex-1" : ""
          )}
          type="button"
          disabled={disabled}
          data-testid="pinning-reject-image"
          onClick={() => {
            onReject();
          }}
        >
          {isRejecting ? "Sending\u2026" : "No, send to Human Artist"}
        </button>
        <button
          className={cn(
            "flex items-center justify-center gap-1 rounded-lg border border-[#00834F] bg-[#00834F] px-3.5 py-2 text-xs font-medium !text-white [font-family:inherit] hover:bg-[#006B40] disabled:pointer-events-none disabled:opacity-25",
            compact ? "flex-1" : ""
          )}
          type="button"
          disabled={disabled}
          data-testid="pinning-approve-image"
          onClick={() => {
            onApprove();
          }}
        >
          <CheckIcon className="h-4 w-4" data-testid="h-4" />{" "}
          {isApproving && !isRejecting ? "Saving\u2026" : "Yes, Save"}
        </button>
      </div>
    </div>
  );
}
